module.exports = __webpack_public_path__ + "img/گوشه-تیز.43a1808a.jpg";